import "./extensions/index.ts";

import TagManager from "@sooro-io/react-gtm-module";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.tsx";

TagManager.initialize({
  gtmId: "GTM-PXZ2XFGW",
  source: "https://gtm.pimento.design/gtm.js",
  auth: "O1e06PcGohvFWirGF9FO5Q",
  preview: "env-1",
});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
